module.exports = __webpack_public_path__ + "./static/img/icon-2.fca0b084cf8a8b5c00c46dca157659cd.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/join/icon-2.png
// module id = ./client/src/assets/img/join/icon-2.png
// module chunks = 0